import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsGF: CultureInfo = {
  name: 'es-GF',
  displayName: 'español (Guayana Francesa)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-GF',
  parent: CultureInfoEs
};
